import * as React from "react";
import {Translations} from "../translations/Translations";
import {InputFieldState} from "./InputFieldState";
import {ChangeEvent, useEffect, useState} from "react";
import {MediaGallery, MediaGalleryImage} from "./MediaGallery";

type GalleryInputProps = {
    trn: Translations,
    state: InputFieldState,
    onChange?: (value: string) => void;
    label: string,
    maxImages: number,
}

type GalleryInputImageState = { image: any, setImage: any };

export const GalleryInput = ({trn, state, onChange, label, maxImages}: GalleryInputProps) => {

    const [images, setImages] = useState<MediaGalleryImage[]>([]);
    let [newImage, setNewImage] = useState<MediaGalleryImage>(null);

    useEffect(() => {
        if (state.value) {
            let images = JSON.parse(state.value.toString());
            setImages(images);
        }
    }, [state]);

    const updateImage = (id: number, newImage: MediaGalleryImage) => {
        let newImages = [...images]

        if (newImage) {
            newImages[id] = newImage;
        } else {
            newImages.splice(id, 1);
        }

        setImages(newImages);
        onChange(JSON.stringify(newImages));
    }

    const addImage = (newImage: MediaGalleryImage) => {
        setNewImage(newImage);
        let newImages = [...images]
        newImages.push(newImage);
        setImages(newImages);
        setNewImage(null);
        onChange(JSON.stringify(newImages));
    }

    return <div>
        <label><span className="labelText">{label}</span></label>

        <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%'}}>
            {images.map((image, id) => {
                return <div style={{flex: '28%', margin: '1%'}}>
                    <MediaGallery image={image} label={null}
                                  onChange={(newImage) => updateImage(id, newImage)}
                                  buttonText={trn.selectImage}/>
                </div>
            })}

            {images.length < maxImages &&
                <div style={{flex: '38%', margin: '1%'}}>
                    <MediaGallery image={newImage} label={null}
                                  onChange={(newImage) => addImage(newImage)}
                                  buttonText={trn.selectImage}/>
                </div>
            }
        </div>
    </div>
}
